<script setup lang="ts">
const props = defineProps<{
  title?: string
  items?: InfoBoxItem[]
}>()

const { start, end } = useGroupBy(props.items, 'desktopColumn')

interface InfoBoxItem {
  icon: StoryBlokIcon
  title?: string
  text?: string
  desktopColumn?: string
}
</script>

<template>
  <section class="flex flex-col gap-5 lg:w-full lg:max-w-1160px lg:mx-auto lg:px-5 xl:px-0 text-dark-50">
    <h2>{{ title }}</h2>
    <!-- MOBILE VIEW -->
    <div class="flex flex-col p-5 border border-gray-300 rounded-xl gap-5 md:hidden">
      <div v-for="item in items" class="flex flex-1 items-center gap-2.5">
        <AppIcon v-bind="item.icon" class="text-primary" />
        <div>
          <span class="text-size-small">{{ item.title }}</span>
          <h4>{{ item.text }}</h4>
        </div>
      </div>
    </div>
    <!-- DESKTOP VIEW -->
    <div class="border border-gray-300 rounded-xl p-8 hidden md:flex">
      <div class="flex flex-col gap-8 min-w-1/2">
        <div v-for="item in start" class="flex items-center gap-2.5">
          <AppIcon v-bind="item.icon" class="text-primary" />
          <div>
            <span class="text-size-small">{{ item.title }}</span>
            <h4>{{ item.text }}</h4>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-8 min-w-1/2">
        <div v-for="item in end" class="flex items-center gap-2.5">
          <AppIcon v-bind="item.icon" class="text-primary" />
          <div>
            <span class="text-size-small">{{ item.title }}</span>
            <h4>{{ item.text }}</h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
